import { useEffect, useState } from 'react';
import { Box, Button, Autocomplete, TextField, Typography } from '@material-ui/core';
import { GetOtherPageGroups, PageGroupUserGroupMapping } from './ConnectionService'; 

const AddExistingMenu = ({ onCancel, onSave, userGroupKey }) => {
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [menus, setMenus] = useState([]);

  useEffect(() => {
    const fetchMenus = async () => {
      if (userGroupKey) {
        const res = await GetOtherPageGroups(userGroupKey);
        setMenus(res);
      }
    };

    fetchMenus();
  }, [userGroupKey]);

  const handleChange = (event, value) => {
    setSelectedMenu(value);
  };

  const handleSave = async () => {
    if (selectedMenu) {
      const data = {
        pageGroupKey: selectedMenu.pageGroupKey,
        targetUserGroupKey: userGroupKey
      };
      await PageGroupUserGroupMapping(data);
      onSave(selectedMenu.pageGroupKey);
    }
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ my: 2 }}>Do you want to add an existing Menu?</Typography>
      <Autocomplete
        options={menus}
        getOptionLabel={(option) => option.pageGroupName}
        onChange={handleChange}
        renderInput={(params) => <TextField {...params} label="Select Menu" variant="outlined" />}
        fullWidth
      />
      <Box mt={2}>
        <Button onClick={onCancel} variant="contained" sx={{ background: 'linear-gradient(to bottom, #939ca3, #939ca3)', minWidth: 100 }}>No</Button>
        <Button onClick={handleSave} variant="contained" sx={{ backgroundColor: "linear-gradient(to bottom, #072f40, #072f40)" }} style={{ marginLeft: '8px' }}>Yes</Button>
      </Box>
    </Box>
  );
};

export default AddExistingMenu;
